import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch, mapDropdown } from '@/utils'

export default {
  async getSchedulers(params) {
    try {
      const response = await axios.get('uni/schedules', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        const { records } = data.data
        const { total } = data.data
        return { records, total }
      }
    } catch (e) {
      handleCatch(e)
    }
  },

  async createSchedule(dataObj) {
    try {
      const response = await axios.post('uni/schedules/createSchedule', dataObj)
      const { data } = response
      return {
        isSuccessful: data.code === ApiCode.SUCCESS,
        message: data.message,
      }
    } catch (e) {
      handleCatch(e)
    }
  },

  async updateSchedule(dataObj) {
    try {
      const response = await axios.put('uni/schedules', dataObj)
      const { data } = response
      return {
        isSuccessful: data.code === ApiCode.SUCCESS,
        message: data.message,
      }
    } catch (e) {
      handleCatch(e)
    }
  },

  async deleteScheduleByCreditClassAndRoomAndTeacher(item) {
    try {
      const response = await axios.delete(`uni/schedules/${item.creditClassId}/${item.roomId}/${item.teacherId}/${item.yearWeekId}/${item.checkRemoveAll}`)
      const { data } = response
      return {
        isSuccessful: data.code === ApiCode.SUCCESS,
        message: data.message,
      }
    } catch (e) {
      handleCatch(e)
    }
  },

  async getDays() {
    const response = await axios.get('uni/days/get_all_day')
    const { data } = response
    if (data.code === ApiCode.SUCCESS) {
      const records = data.data
      return mapDropdown(records)
    }
  },

  async getYearWeek(params) {
    const response = await axios.get('uni/course/semesters/get_week', { params })
    const { data } = response
    if (data.code === ApiCode.SUCCESS) {
      return data.data
    }
  },

  async getSchedulersV3(params) {
    try {
      const response = await axios.get('uni/schedules/getSchedulesV3', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        const { records } = data.data
        const { total } = data.data
        return { records, total }
      }
    } catch (e) {
      handleCatch(e)
    }
  },

  async getTurns() {
    try {
      const response = await axios.get('uni/turns/get_all_turn')
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
    } catch (e) {
      handleCatch(e)
    }
  },

  async exportScheduler(params) {
    try {
      const responseStudentInfo = await axios({
        method: 'get',
        url: 'uni/reports/reportScheduler',
        responseType: 'blob',
        params,
      })
      return responseStudentInfo.data
    } catch (e) {
      handleCatch(e)
    }
  },
}
